var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContentLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10623_106374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8868 21.8038H3.11855C2.29097 21.8024 1.49776 21.4727 0.913077 20.887C0.328389 20.3013 -1.20912e-06 19.5075 0 18.68L0 11.1185C0.00141188 10.2919 0.330426 9.4995 0.914961 8.91496C1.4995 8.33043 2.29189 8.00141 3.11855 8H26.8868C27.713 8.00141 28.5048 8.3306 29.0885 8.91529C29.6722 9.49997 30 10.2924 30 11.1185V18.68C30.0007 19.0895 29.9207 19.4952 29.7647 19.8738C29.6086 20.2524 29.3795 20.5966 29.0904 20.8867C28.8013 21.1767 28.4579 21.407 28.0798 21.5644C27.7017 21.7218 27.2963 21.8031 26.8868 21.8038ZM3.11855 9.1748C2.60303 9.1748 2.10863 9.37958 1.74411 9.74411C1.37958 10.1086 1.1748 10.603 1.1748 11.1185V18.68C1.1748 19.1955 1.37958 19.6899 1.74411 20.0544C2.10863 20.4189 2.60303 20.6237 3.11855 20.6237H26.8868C27.1425 20.6244 27.3958 20.5747 27.6323 20.4773C27.8687 20.3799 28.0836 20.2369 28.2647 20.0563C28.4457 19.8757 28.5894 19.6612 28.6874 19.425C28.7854 19.1889 28.8359 18.9357 28.8359 18.68V11.1185C28.8359 10.8628 28.7854 10.6096 28.6874 10.3735C28.5894 10.1373 28.4457 9.92278 28.2647 9.74222C28.0836 9.56165 27.8687 9.41859 27.6323 9.32122C27.3958 9.22385 27.1425 9.17409 26.8868 9.1748H3.11855Z",
    fill: "#B1B5C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10623_106374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 13.8038,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentLeft);
export default __webpack_public_path__ + "static/media/ic_content_left.c5ce30f330ce06f9b4f7462b7c33d839.svg";
export { ForwardRef as ReactComponent };